import { render, staticRenderFns } from "./TopUp.vue?vue&type=template&id=44ca071c"
import script from "./TopUp.vue?vue&type=script&lang=js"
export * from "./TopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports